'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _commonFormsy = require('../common-formsy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PriorFundingFormGroup = (_dec = (0, _mobxReact.inject)('PriorFundingStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(PriorFundingFormGroup, _Component);

  function PriorFundingFormGroup(props) {
    _classCallCheck(this, PriorFundingFormGroup);

    var _this = _possibleConstructorReturn(this, (PriorFundingFormGroup.__proto__ || Object.getPrototypeOf(PriorFundingFormGroup)).call(this, props));

    _initDefineProp(_this, 'funderName', _descriptor, _this);

    _this.funderName = props.priorFunding.funder_name;
    return _this;
  }

  _createClass(PriorFundingFormGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.PriorFundingStore.fetchPriorFundingOptions();
    }
  }, {
    key: 'onFunderNameInputChange',
    value: function onFunderNameInputChange(value) {
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== undefined) {
        this.funderName = value;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          PriorFundingStore = _props.PriorFundingStore,
          priorFunding = _props.priorFunding,
          required = _props.required,
          priorFundingOptions = PriorFundingStore.priorFundingOptions;


      return _react2.default.createElement(
        'div',
        { className: 'form-group-merged' },
        _react2.default.createElement(
          _Row2.default,
          { key: 'buyout' },
          _react2.default.createElement(_commonFormsy.Input, {
            name: 'prior_funding.funder_name',
            type: 'hidden',
            value: this.funderName
          }),
          _react2.default.createElement(_commonFormsy.Typeahead, {
            allowNew: true,
            label: 'Funder Name',
            name: 'prior_funding.funder_name_typeahead',
            onInputChange: this.onFunderNameInputChange,
            options: (0, _mobx.toJS)(priorFundingOptions),
            value: this.funderName,
            required: required && !!priorFunding.buyout_amount
          })
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(_commonFormsy.Input, {
            label: 'Buyout Amount',
            name: 'prior_funding.buyout_amount',
            type: 'number',
            value: priorFunding.buyout_amount,
            validations: Object.assign({}, { isNumeric: true, isPositive: true }, required && {
              isRequiredFor: 'prior_funding.funder_name_typeahead'
            }),
            validationErrors: {
              isNumeric: 'Buyout Amount must be a number.',
              isPositive: 'Buyout Amount must be positive.',
              isRequiredFor: 'Buyout Amount is required.'
            }
          })
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(_commonFormsy.DateInput, {
            label: 'Expires On',
            name: 'prior_funding.expiration_date',
            value: priorFunding.expiration_date,
            validations: required && { isRequiredForMultiple: ['prior_funding.buyout_amount', 'prior_funding.funder_name_typeahead'] },
            validationErrors: {
              isRequiredForMultiple: 'Must include Buyout Amount and Funder Name.'
            }
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PriorFundingFormGroup;
}(_react.Component), _class3.defaultProps = {
  required: false
}, _class3.propTypes = {
  priorFunding: _propTypes2.default.object.isRequired,
  PriorFundingStore: _propTypes2.default.object.isRequired,
  required: _propTypes2.default.bool
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'funderName', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
})), _class2)) || _class) || _class) || _class);
var _default = PriorFundingFormGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PriorFundingFormGroup, 'PriorFundingFormGroup', '/app/src/components/common-prior-fundings/PriorFundingFormGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common-prior-fundings/PriorFundingFormGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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